import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
} from "@chakra-ui/react";
import { ModalFormPayProps, IModalFormPay } from "./interface";
import React from "react";
import { useForm } from "react-hook-form";
import ModalDefault from "../ModalDefault";
import { FooterType } from "../ModalDefault/interface";
import TextRequired from "../TextRequired";

const ModalFormPay: React.FC<ModalFormPayProps> = ({
  onSubmit,
  onClose,
  ...props
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<IModalFormPay>();

  return (
    <ModalDefault
      title="Pay Invoice"
      {...props}
      footerType={FooterType.FORM}
      onButtonSaveClick={() => {
        handleSubmit(onSubmit)();
      }}
      onClose={() => {
        reset();
        onClose();
      }}
      onButtonCancelClick={() => {
        reset();
        onClose();
      }}
    >
      <form autoComplete="off">
        <FormControl isInvalid={errors.hasOwnProperty("paidAt")}>
          <FormLabel fontSize="sm">
            Paid At
            <TextRequired>*</TextRequired>
          </FormLabel>
          <Input
            size="sm"
            type="date"
            {...register("paidAt", { required: true })}
            w="200px"
          />
          <FormErrorMessage>
            {errors.paidAt?.type === "required" && "Paid at is required!"}
          </FormErrorMessage>
        </FormControl>
      </form>
    </ModalDefault>
  );
};

export default ModalFormPay;
